module.exports = __webpack_public_path__ + "media/images/loading-0d7a9658ab754afcfcbd3bc2adc261a2.gif";